import { AfterContentInit, ChangeDetectorRef, Component, OnDestroy, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { environment } from '@env/environment';
import { LoaderService } from '@service/loader.service';
import { Subject, takeUntil } from 'rxjs';

import { LoaderComponent } from '../shared/components/loader/loader.component';

@Component({
  selector: 'app-taskpane',
  templateUrl: './taskpane.component.html',
  styleUrls: ['./taskpane.component.scss'],
  imports: [
    LoaderComponent,
    RouterOutlet
  ],
})
export class TaskpaneComponent implements OnDestroy, AfterContentInit {
  private cdr = inject(ChangeDetectorRef);
  private loader = inject(LoaderService);

  private readonly $ngDestroyed = new Subject<void>();

  showLoader = false;
  isDemoMode = environment.environment === 'demo';

  ngAfterContentInit(): void {
    this.loader.loaderVisible$.pipe(takeUntil(this.$ngDestroyed)).subscribe((visible) => {
      this.showLoader = visible;
      this.cdr.detectChanges();
    });
  }

  ngOnDestroy(): void {
    this.$ngDestroyed.next(undefined);
    this.$ngDestroyed.complete();
  }
}
